(() => {
  const fieldSelector = '[data-hear-about-us]';
  const otherOption = 'Other (please specify)';
  const timers = new WeakMap();

  const updateVisibility = (field) => {
    const select = field.querySelector('[data-hear-about-us-select]');
    const otherField = field.querySelector('[data-hear-about-us-other]');
    const otherInput = field.querySelector('[data-hear-about-us-other-input]');
    const showOther = select.value === otherOption;

    otherField.hidden = !showOther;
    otherInput.required = showOther;
    if (!showOther) otherInput.setCustomValidity('');
    select.setAttribute('aria-expanded', String(showOther));
  };

  const saveCartAttributes = (field, delay = 0) => {
    if (field.dataset.context !== 'cart') return;

    window.clearTimeout(timers.get(field));
    timers.set(field, window.setTimeout(() => {
      const select = field.querySelector('[data-hear-about-us-select]');
      const otherInput = field.querySelector('[data-hear-about-us-other-input]');
      const rootUrl = window.theme?.routes?.root_url || window.Shopify?.routes?.root || '/';
      const updateUrl = `${rootUrl.replace(/\/?$/, '/')}cart/update.js`;

      fetch(updateUrl, {
        method: 'POST',
        credentials: 'same-origin',
        keepalive: true,
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          attributes: {
            'How did you hear about us?': select.value,
            'How did you hear about us - Other': select.value === otherOption ? otherInput.value : ''
          }
        })
      }).catch(() => {
        // The fields are also submitted with the cart form as a fallback.
      });
    }, delay));
  };

  document.addEventListener('change', (event) => {
    const field = event.target.closest(fieldSelector);
    if (!field) return;

    if (event.target.matches('[data-hear-about-us-select]')) {
      updateVisibility(field);
    }
    saveCartAttributes(field);
  });

  document.addEventListener('input', (event) => {
    if (!event.target.matches('[data-hear-about-us-other-input]')) return;

    event.target.setCustomValidity('');
    const field = event.target.closest(fieldSelector);
    if (field) saveCartAttributes(field, 250);
  });

  document.addEventListener('submit', (event) => {
    const field = [...document.querySelectorAll(fieldSelector)].find((item) => {
      return item.querySelector('[data-hear-about-us-select]').form === event.target;
    });
    if (!field) return;

    const select = field.querySelector('[data-hear-about-us-select]');
    const otherInput = field.querySelector('[data-hear-about-us-other-input]');
    if (select.value !== otherOption || otherInput.value.trim()) return;

    event.preventDefault();
    otherInput.setCustomValidity('Please specify how you heard about us.');
    otherInput.reportValidity();
    otherInput.focus();
  });

  document.querySelectorAll(fieldSelector).forEach(updateVisibility);
})();
